import { FormikProps } from "formik";
import { useMemo } from "react";
import {
  EquipmentItemViewModel,
  ItemViewModel,
  SubmitBlankMediaImporterApplication,
} from "../../../../../../generated/data-contracts";
import { AvisLoader } from "../../../../../shared/components";
import {
  BlankMediaApplicationCountries,
  BlankMediaApplicationExpropriations,
  BlankMediaApplicationManufEquipments,
  BlankMediaApplicationSales,
  BlankMediaApplicationSummaries,
} from "./";

interface IApplicationSectionsProps {
  bag: FormikProps<SubmitBlankMediaImporterApplication>;
  equipments: EquipmentItemViewModel[] | undefined;
  countries: ItemViewModel[] | undefined;
  professionalUsers: ItemViewModel[] | undefined;
  manufacturers: ItemViewModel[] | undefined;
  disabled: boolean | undefined;
  loading: boolean | undefined;
}
export function ApplicationSections(
  props: Readonly<IApplicationSectionsProps>,
) {
  const {
    bag,
    equipments,
    countries,
    professionalUsers,
    manufacturers,
    disabled,
    loading,
  } = props;

  const equipmentsWithPercentageRate = useMemo(() => {
    if (!equipments) return [];

    return equipments.filter((eqip) => (eqip?.percentage ?? 0) > 0);
  }, [equipments]);
  if (!equipments || !countries || !professionalUsers || !manufacturers)
    return <AvisLoader inline />;

  if (bag.values.dealNotOccuredPortal) return;

  return (
    <div className="blank-media-importer-application-sections">
      <BlankMediaApplicationSales
        bag={bag}
        bagField="sales"
        equipments={equipments}
        professionalUsers={professionalUsers}
        manufacturers={manufacturers}
        disabled={disabled}
        loading={loading}
      />
      <BlankMediaApplicationCountries
        bag={bag}
        bagField="importedFromCountries"
        equipments={equipments}
        countries={countries}
        disabled={disabled}
        loading={loading}
        mode="Import"
      />
      <BlankMediaApplicationCountries
        bag={bag}
        bagField="exportedToCountries"
        equipments={equipments}
        countries={countries}
        disabled={disabled}
        loading={loading}
        mode="Export"
      />
      <BlankMediaApplicationManufEquipments
        bag={bag}
        bagField="manufEquipments"
        equipments={equipments}
        disabled={disabled}
        loading={loading}
      />
      <BlankMediaApplicationExpropriations
        bag={bag}
        bagField="expropriations"
        equipments={equipmentsWithPercentageRate}
        disabled={disabled}
        loading={loading}
      />
      <BlankMediaApplicationSummaries
        bag={bag}
        bagField="summaries"
        equipments={equipments}
        disabled={true} //Always disabled
        loading={loading}
      />
      {loading && <AvisLoader />}
    </div>
  );
}
